import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export interface Brand { id: string; organizationId: string; name: string; slug: string; isDefault: boolean; tagline: string | null; segment: string | null; website: string | null; description: string | null; projects: number }

/** Marcas de um cliente. Com uma só (a padrão), a camada não aparece em tela nenhuma. */
export function useBrands(organizationId: string | null | undefined) {
  const q = useQuery({ queryKey: ['brands', organizationId], enabled: Boolean(organizationId), queryFn: () => api.get<Brand[]>(`/organizations/${organizationId}/brands`), staleTime: 30_000 });
  const brands = q.data ?? [];
  return { brands, multi: brands.length > 1, byId: (id: string | null | undefined) => brands.find((b) => b.id === id) ?? null, loading: q.isPending };
}
/** Sufixo de consulta para filtrar por marca. */
export const brandQuery = (brandId?: string | null, first = true) => (brandId ? `${first ? '?' : '&'}brandId=${brandId}` : '');
